import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import NavBar from "../components/NavbarTwo";
import FooterFour from "../components/FooterFour";

const Privacy = () => {
  return (
    <>
      <SEO canonical="/privacy" {...PAGES["/privacy"]} />
      <NavBar />
      <div className="contact-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="contact-page-inner bg-gray">
            <div className="section-title mb-4 pb-2">
              <h1 className="title">Privacy Policy </h1>
              <p className="content mb-0">
              Evolvelab Solutions Inc.  ("us", "we", or "our") operates the https://evolvelab.co  (the "Site"). This page informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site.
              We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.
              </p>
              <p className="content mb-0">  
                <h2>Information Collection and Use</h2>
                While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your name, email address, postal address, and phone number ("Personal Information").
              </p>
              <p className="content mb-0"> 
              <h2>Cookies</h2>

              Cookies are files with small amounts of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.
              Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.

              </p>
              <p className="content mb-0"> 
              <h2>Security</h2>
              The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
              </p>
              <p className="content mb-0"> 
              <h2>Links to Other Sites</h2>
              Our Site may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
              </p>
              <p className="content mb-0"> 
              <h2>Changes to This Privacy Policy</h2>
              This Privacy Policy is effective as of [Date] and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.
              We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.

              </p>
              <p className="content mb-0"> 
              <h2>Contact Us</h2>
              If you have any questions about this Privacy Policy, please contact us at <a href="mailto:mike@evolvelab.co">mike@evolvelab.co</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <FooterFour />
    </>
  );
};

export default Privacy;
